// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-article-small/carousel-article-small.component.scss
// module id = 464
// module chunks = 0